import request from "@/utils/request";

export default function uploadServerQRCode(params) {
    return request({
        url: `/commonUser/uploadServerQRCode`,
        method: 'get',
        params:params
    })
}
